var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingio-spinner-dual-ring-yv5sd3a663b"},[_c('div',{staticClass:"ldio-g3co1sy13xg"},[_c('div'),_vm._v(" "),_c('div',[_c('div')])])])
}]

export { render, staticRenderFns }